<!-- =========================================================================================
    File Name: KnowledgeBase.vue
    Description: Knowledge Base Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="landing">
    <!-- header -->
    <div class="landing-header" name="home">
      <div class="overlay"></div>
      <div class="cmp-logo"></div>
      <div class="header-top">
        <ul class="landing-menu">
          <li class="landing-menu-item mr-5">
            <a href="#home">首页</a>
          </li>
          <li class="landing-menu-item">
            <a href="#features">特色</a>
          </li>
        </ul>
        <div class="landing-logo">
          <img src="../../assets/images/pages/landing/logo-hopesen1.png" alt />
        </div>
        <div class="button-group">
          <vs-button
            class="auth_btn"
            to="/pages/login"
            color="rgb(255, 255, 255)"
            type="flat"
          >{{$t('login')}}</vs-button>
          <vs-button
            class="auth_btn"
            to="/pages/register"
            color="rgb(255, 255, 255)"
            type="flat"
          >{{$t('register')}}</vs-button>
          <span
            class="text-white cursor-pointer ml-2"
            @click="isChinese=!isChinese"
            v-if="isChinese"
          >English</span>
          <span
            class="text-white cursor-pointer ml-2"
            @click="isChinese=!isChinese"
            v-if="!isChinese"
          >中文</span>
        </div>
      </div>
      <div class="header-content">
        <h1>{{$t('lpTitle')}}</h1>
        <p>{{$t('lpDesc')}}</p>
        <vs-button to="/pages/login" color="primary" type="filled" class="mt-3">{{$t('lpBnrBtn')}}</vs-button>
      </div>
    </div>

    <!-- features  -->
    <div class="landing-content" name="features">
      <div class="vx-row mt-8">
        <div
          class="vx-col w-full md:w-1/3 sm:w-1/2 mb-base"
          v-for="item in filteredKB"
          :key="item.id"
          @click="$router.push(item.url).catch(() => {})"
        >
          <vx-card class="text-center cursor-pointer">
            <img :src="item.graphic" alt="graphic" width="180" class="mx-auto mb-4" />
            <h4 class="mb-2">{{ $t(item.title) }}</h4>
            <small>{{ $t(item.description) }}</small>
          </vx-card>
        </div>
      </div>
    </div>
    <!-- apply join company -->
    <!-- <div class="apply">
          <p>You have not joined the company, please enter the company name and click Apply</p>
          <div class="select">
            <vs-input @focus="flag=true" @blur="blur" placeholder="company name" v-model="searchVal" class="mt-8" />

            <ul class="select-list" v-if="selectList.length > 0">
              <li class="select-list-item" @click="selectItem(item)" v-for="(item, index) in selectList" :key="index">
                <span>{{item.company.name}}</span>
              </li>
            </ul>
          </div>
          <vs-button type="border" class="mt-6" @click="apply" :disabled="vilidateApply">Apply</vs-button>
    </div>-->

    <!-- footer -->
    <div class="landing-footer">
      <p>
        版权所有 © 2016 深圳市鸿普森科技股份有限公司 版权所有
        <a href="https://beian.miit.gov.cn" target="_blank">粤ICP备15067157号</a>
      </p>
    </div>
  </div>
</template>

<script>
// import openapi from '@/api/openapi.js';

// import { setTimeout } from 'timers';
export default {
  name: "landing",
  data() {
    return {
      knowledgeBaseSearchQuery: "",
      kb: [
        {
          id: 1,
          title: `lpserviceTitle1`,
          description: `lpserviceDesc1`,
          graphic: require("@/assets/images/pages/landing/management.svg")
        },
        {
          id: 2,
          title: `lpserviceTitle2`,
          description: `lpserviceDesc2`,
          graphic: require("@/assets/images/pages/landing/itil.svg")
        },
        {
          id: 3,
          title: `lpserviceTitle3`,
          description: `lpserviceDesc3`,
          graphic: require("@/assets/images/pages/landing/saas.svg")
        }
        // {
        //   id: 4,
        //   title: 'IoT',
        //   description : 'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. ',
        //   graphic: require("@/assets/images/pages/landing/iot.svg"),
        // },
      ],
      searchVal: "",
      selectList: [],
      selectListShow: false,
      flag: true,
      bizCode: -1,
      isChinese: this.$i18n.locale == "zh"
    };
  },
  watch: {
    isChinese(val) {
      let locale = val ? "zh" : "en";
      this.$i18n.locale = locale;
    }
    // searchVal(val) {
    //   if(this.flag) {
    //     this.getList(val);
    //     this.bizCode = -1;
    //   }
    // }
  },
  computed: {
    filteredKB() {
      return this.kb.filter(
        item =>
          item.title
            .toLowerCase()
            .includes(this.knowledgeBaseSearchQuery.toLowerCase()) ||
          item.description
            .toLowerCase()
            .includes(this.knowledgeBaseSearchQuery.toLowerCase())
      );
    }
    // vilidateApply() {
    //   return this.flag
    // }
  },
  methods: {
    // apply() {
    //   this.$tools.ajax(openapi.apply, 'post', {bizCode: this.bizCode}).then((data) => {
    //     this.$vs.notify({
    //       position: 'top-center',
    //       time: 3000,
    //       color: 'success',
    //       text: 'Apply Successful'
    //     })
    //   }).catch((err) => {
    //     this.$vs.notify({
    //       position: 'top-center',
    //       time: 3000,
    //       color: 'warning',
    //       text: `Apply failed for ${err.response.data}`
    //     })
    //   })
    // },
    // blur(e) {
    //   setTimeout(()=> {
    //     if(this.flag) this.searchVal = ''
    //   }, 300)
    // },
    // // 列表点击事件
    // selectItem(item) {
    //   this.searchVal = item.company.name;
    //   this.flag = false;
    //   this.selectList = [];
    //   this.bizCode = item.bizCode;
    // },
    // // 获取列表
    // getList(val) {
    //   if(val.length >= 2) {
    //     this.$tools.ajax(`${openapi.keyword}{keyword}`, 'get', {keyword: val, type: 'BUSINESS'}).then((data) => {
    //       this.selectList = data;
    //     })
    //   } else {
    //     this.selectList = [];
    //   }
    // }
  },
  components: {}
};
</script>

<style lang="scss">
.landing {
  position: relative;
  min-height: calc(100vh);
  .landing-header {
    height: 450px;
    padding: 30px;
    background: url("../../assets/images/pages/vuexy-login-bg1.jpg") no-repeat;
    // background-position: center center;
    // background-repeat: no-repeat;
    background-size: cover;
    box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.1);
    position: relative;
    .overlay {
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
      top: 0;
      z-index: 0;
      background-color: rgba(0, 0, 0, 0.3);
    }
    .cmp-logo {
      position: absolute;
      width: 166px;
      height: 57px;
      background-image: url('../../assets/images/logo/logo_small.png');
      background-repeat: no-repeat;
      background-size: cover;
    }
    .header-top {
      height: 150px;
      display: flex;
      justify-content: space-between;
      position: relative;
      z-index: 2;
      .landing-menu {
        opacity: 0;
        .landing-menu-item {
          display: inline-block;
          a {
            color: #fff;
          }
        }
      }
      .landing-logo {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        img {
          width: 200px;
        }
      }
      .button-group {
        .auth_btn {
          padding: 0 !important;
          padding-right: 10px !important;
          border-right: 1px solid #fff !important;
          border-radius: 0;
          padding-left: 10px !important;
          &:hover,
          &:focus {
            background: transparent !important;
          }
        }
      }
    }
    .header-content {
      text-align: center;
      color: #fff;
      h1 {
        z-index: 2;
        color: #fff;
        font-size: 32px;
        margin: 18px 0;
        text-shadow: 0 0 5px #000;
        position: relative;
      }
      p {
        z-index: 2;
        font-size: 22px;
        font-weight: 300;
        color: #fff;
        text-shadow: 0 0 5px #000;
        position: relative;
        width: 85%;
        margin: 0 auto;
      }
      // .vs-button {
      //   background: #7366f0 !important;
      //   &:hover {
      //     box-shadow: 0 8px 25px -8px rgba(#4c3dda,1)
      //   }
      // }
    }
  }
  .landing-content {
    padding: 0 10px;
    min-height: calc(100vh - 550px);
    .vx-card {
      min-height: 270px;
      h4 {
        color: #333;
      }
      small {
        font-size: 14px;
        color: #474747;
      }
      .vx-card__body {
        img {
          width: 180px;
          height: 80px;
        }
      }
    }
  }
  .apply {
    height: 250px;
    text-align: center;
    .select {
      width: 300px;
      margin: 0 auto;
      position: relative;
      .vs-input {
        width: 300px;
      }
      ul.select-list {
        background-color: #fff;
        padding: 3px;
        position: absolute;
        width: 100%;
        z-index: 999;
        li.select-list-item:hover {
          background-color: #eee;
        }
      }
    }
  }
  .landing-footer {
    // position: relative;
    left: 0;
    bottom: 0;
    height: 100px;
    width: 100%;
    // background-color: rgb(30, 101, 181);
    background-color: #000;
    color: #fff;
    text-align: center;
    line-height: 100px;
    a {
      // color: white;
      text-decoration: none;
    }
  }
}
</style>
